import './teams.scss';

import { Button, TeamsTableWrapper } from '@basqet-dashboard/common/components';
import { PERMISSIONS } from '@basqet-dashboard/common/config';
import { useHasPermission } from '@basqet-dashboard/common/hooks';
import { useFetchTeam } from '@basqet-dashboard/common/hooks/queries';
import React, { useState } from 'react';

import { InviteTeamMember } from './invite-team-member';
import RolesPermissions from './roles-permissions';

const TeamsPage = () => {
  const { teamMembers, isFetching, isLoading } = useFetchTeam();

  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const openEditModal = (member) => {
    setSelectedMember(member);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedMember(null);
    setModalOpen(false);
  };

  const hasPermission = useHasPermission();
  const canManageTeam = hasPermission(PERMISSIONS.TEAMS_MANAGE);

  const formattedTeamData = teamMembers.map((member) => {
    const { first_name, last_name, email, status, role } = member;
    const name = `${first_name} ${last_name}`;
    const normalizedStatus = status.toLowerCase();

    const memberStatusBadge = (
      <div className="teams__badge-container">
        <span className={`teams__badge ${normalizedStatus}`}>{status}</span>
      </div>
    );

    const action = (
      <Button variant="outline" size="table" onClick={() => openEditModal(member)}>
        Edit
      </Button>
    );

    return { name, status: memberStatusBadge, email, role, action: canManageTeam ? action : '-' };
  });

  const defaultRoles = [
    { name: 'Owner', description: 'Full access to everything.' },
    { name: 'Administrator', description: 'Full access, cannot delete Owner.' },
    { name: 'Developer', description: 'Manage API keys and integrations only.' },
    { name: 'Support', description: 'View-only access to transactions and customers.' }
  ];

  return (
    <div className="teams">
      <TeamsTableWrapper
        data={formattedTeamData}
        isFetching={isLoading || isFetching}
        title="Team"
        name="members"
        openModal={() => {
          if (!canManageTeam) return;

          setSelectedMember(null); // ensure it's create mode
          setModalOpen(true);
        }}
        headerName="teams"
      />

      {isModalOpen && canManageTeam && (
        <InviteTeamMember
          closeModal={closeModal}
          teamMember={selectedMember} // pass selected member
        />
      )}

      <RolesPermissions roles={defaultRoles} />
    </div>
  );
};

export default TeamsPage;
